module.exports = __webpack_public_path__ + "assets/img/bluebird-logo-grey.4eec52b8.svg";